import React from 'react';
import { Guid, ResourceType } from '../../helpers/ResourceHelper';
import ResourceSelectionControl from './ResourceSelectionControl';
import IntermediateCheckbox, { IntermediateCheckboxState } from '../IntermediateCheckbox';
import { StateContext } from '../../services/LabSimService';
import styles from './SectionSelectionControl.module.less';
import { decodeUnicodeEscapes } from '../../helpers/TextHelper';
export default class SectionSelectionControl extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckbox = (checkedState) => {
            const allOnOrOff = checkedState === IntermediateCheckboxState.CHECKED;
            const filteredChildren = [
                ...(this.props.filterResources(this.props.section.children) || []),
            ];
            const section = this.props.section.resourceGuid !== Guid.EMPTY ? [this.props.section] : [];
            this.setState((newState) => {
                let newChildren = [];
                if (checkedState === IntermediateCheckboxState.CHECKED) {
                    if (this.props.filtersAreNotApplied() || this.props.appliedFilters.module)
                        newChildren = [...section, ...filteredChildren];
                    else
                        newChildren = [...filteredChildren];
                }
                return Object.assign(Object.assign({}, newState), { selectedChildren: newChildren });
            }, () => {
                // fire updates
                this.updateCheckboxState();
                if (this.props.filtersAreNotApplied() || this.props.appliedFilters.module)
                    this.props.onResourceSelect([...section, ...filteredChildren], allOnOrOff);
                else
                    this.props.onResourceSelect([...filteredChildren], allOnOrOff);
            });
        };
        this.onResourceSelect = (resources, checked) => {
            this.setState((state) => {
                let newSelectedChildren;
                if (checked) {
                    const childrenToAdd = resources.filter((r) => state.selectedChildren.indexOf(r) === -1);
                    newSelectedChildren = [...state.selectedChildren, ...childrenToAdd];
                }
                else {
                    newSelectedChildren = state.selectedChildren.filter((r) => resources.indexOf(r) === -1);
                }
                return Object.assign(Object.assign({}, state), { selectedChildren: newSelectedChildren });
            }, () => {
                this.updateCheckboxState();
                this.props.onResourceSelect(resources, checked);
            });
        };
        this.updateCheckboxState = () => {
            const children = (this.props.section.children || []).slice();
            if (this.props.section.resourceGuid !== Guid.EMPTY &&
                (this.props.filtersAreNotApplied() || this.props.appliedFilters.module))
                children.push(this.props.section);
            if (this.state.selectedChildren.length === this.props.filterResources(children).length) {
                this.setState({ checkedState: IntermediateCheckboxState.CHECKED });
            }
            else if (this.state.selectedChildren.length === 0) {
                this.setState({ checkedState: IntermediateCheckboxState.UNCHECKED });
            }
            else {
                this.setState({ checkedState: IntermediateCheckboxState.PARTIAL });
            }
        };
        const hasChildren = (props.section.children && props.section.children.length > 0);
        // has children? include self if guid not empty
        this.state = {
            checkedState: props.checkedState || IntermediateCheckboxState.UNCHECKED,
            hasChildren: hasChildren,
            selectedChildren: props.selectedChildren || [],
        };
    }
    componentDidMount() {
        this.updateCheckboxState();
    }
    shouldComponentUpdate(nextProps, nextState) {
        if ((this.props.selectedChildren !== nextProps.selectedChildren ||
            this.state.selectedChildren !== nextProps.selectedChildren) &&
            (this.props.checkedState !== nextProps.checkedState ||
                this.state.checkedState !== nextProps.checkedState)) {
            this.setState({
                selectedChildren: nextProps.selectedChildren,
                checkedState: nextProps.checkedState,
            });
        }
        return true;
    }
    sectionToList(section) {
        let resources = [];
        if (section.resourceGuid !== Guid.EMPTY &&
            (this.props.filtersAreNotApplied() || this.props.appliedFilters.module)) {
            resources = [
                React.createElement("div", { key: section.resourceGuid, className: styles.childItem },
                    React.createElement(ResourceSelectionControl, { resource: section, titleOverride: 'Section Heading', onSelect: this.onResourceSelect, selectedChildren: this.state.selectedChildren, checked: this.state.selectedChildren.indexOf(section) >= 0 })),
            ];
        }
        const filteredResources = this.props.filterResources(section.children || []);
        if (filteredResources) {
            const otherResources = filteredResources.map((resource) => {
                if (resource.resourceGuid === Guid.EMPTY) {
                    return React.createElement(React.Fragment, null);
                }
                return (React.createElement("div", { key: resource.resourceGuid, className: styles.childItem },
                    React.createElement(ResourceSelectionControl, { resource: resource, onSelect: this.onResourceSelect, selectedChildren: this.state.selectedChildren, checked: this.state.selectedChildren.indexOf(resource) >= 0 })));
            });
            resources = [...resources, ...otherResources];
        }
        return resources;
    }
    render() {
        const sectionList = this.sectionToList(this.props.section);
        return (React.createElement("div", { className: styles.item },
            this.state.hasChildren && sectionList.length > 0 && (React.createElement("div", { className: styles.headerItem },
                React.createElement(IntermediateCheckbox, { className: styles.headerHover, name: `${this.props.section.sectionNumber}`, onChange: this.handleCheckbox, checkedState: this.state.checkedState }, `${this.props.section.sectionNumber} ${decodeUnicodeEscapes(this.props.section.sectionTitle)}`))),
            !this.state.hasChildren &&
                (this.props.filtersAreNotApplied() ||
                    this.props.appliedFilters.module ||
                    (this.props.appliedFilters.exam &&
                        this.props.section.type === ResourceType.EXAM)) && (React.createElement("div", { className: styles.noChild },
                React.createElement(ResourceSelectionControl, { key: this.props.section.resourceGuid, resource: this.props.section, onSelect: this.props.onResourceSelect, selectedChildren: this.state.selectedChildren, checked: this.state.selectedChildren.indexOf(this.props.section) >= 0 }))),
            this.state.hasChildren && sectionList.length > 0 && (React.createElement("div", { className: styles.indent }, sectionList))));
    }
}
SectionSelectionControl.contextType = StateContext;
//# sourceMappingURL=SectionSelectionControl.js.map